import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Drawer from '@/components/layout/Drawer';
import AppHeader from '@/components/layout/AppHeader';
import menuItems from '@/utils/menuItems';

function AppView() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // first
    if (location.pathname === '/app' || location.pathname === '/app/') {
      navigate('submissions');
    }
  }, []);

  return (
    <div className="h-screen overflow-hidden bg-background">
      <Drawer parent={'app'} menuItems={menuItems()} />
      <AppHeader />
      <main className="lg:ml-[280px] mt-16 h-[calc(100vh-4rem)] overflow-y-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}

export default AppView;
